export default [
  { text: "reference.status.PRELIMINARY", value: "PRELIMINARY" },
  { text: "reference.status.SENT", value: "SENT" },
  { text: "reference.status.CHECKED", value: "CHECKED" },
  { text: "reference.status.VERIFIED", value: "VERIFIED" },
];
